import { createStore } from 'state-pool';

const orgStore = createStore();

orgStore.setState('newOrgRedirectInfo', {});

export default orgStore;
